export { default } from './setRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/setRef/index.js
// module id = 376
// module chunks = 22